import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import Tab from 'react/containers/layout/tabs/Tab';
import { DataSyncConfigurationList } from './DataSyncConfigurationList';
import DataSyncConfigurationForm from './DataSyncConfigurationForm';

class AuthorizationCredential extends Tab {
  static propTypes = {
    active: PropTypes.bool
  }

  static tabName = 'DataSyncConfiguration'

  activeClassName = 'is-active'

  getParametersFromPathName() {
    const { tab: { extra, pathname } } = this.props;
    const parentId = extra ? extra.parentId : null;
    const { length } = pathname.split('/');
    const index = (length - 2) + (length % 2);
    const [mode, id] = pathname.split('/').slice(index);

    return { mode, id, parentId };
  }

  render() {
    const { active } = this.props;
    const { id } = this.getParametersFromPathName();

    const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;

    return (
      <div id="DataSyncConfiguration" className={className}>
        <Switch>
          <Route exact path="/DataSyncConfiguration" component={DataSyncConfigurationList} />
          <Route path="/DataSyncConfiguration/new" component={() => <DataSyncConfigurationForm />} />
          <Route path="/DataSyncConfiguration/edit/:id" component={() => <DataSyncConfigurationForm id={id} />} />
        </Switch>
      </div>
    );
  }
}

export default AuthorizationCredential;
